import { render, staticRenderFns } from "./Msisdn.vue?vue&type=template&id=3e18753f&"
import script from "./Msisdn.vue?vue&type=script&lang=js&"
export * from "./Msisdn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports